import React, { useState, useRef } from 'react';
import PageLayout from './PageLayout';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// --- 画像ファイルのインポート ---
import ProfileImage from '../images/ProfileImage.jpg';
import pythonImage from '../images/python.png';
import CImage from '../images/C.jpg';
import javascriptImage from '../images/js.png';
import RaspiImage from '../images/raspberrypi.png';

// タイムライン用画像
import DrowsinessGlassesImage from '../images/drowsiness_glasses.jpg';
import TaiwanPBLImage from '../images/taiwan_pbl.jpg';
import TaiwanPBLImage2 from '../images/taiwan_pbl_2.jpg';
import TaiwanPBLImage3 from '../images/taiwan_pbl_3.jpg';
import SitToStandImage from '../images/Standup.jpg';
import AssistGloveImage from '../images/Assistglobe.jpg';
import ExpoImage1 from '../images/expo1.jpg';
import ExpoImage2 from '../images/expo2.jpg';
import ExpoImage3 from '../images/expo3.jpg';
import ExpoImage4 from '../images/expo4.jpg';
import HI2025Image1 from '../images/HI2025_1.jpg';
import HI2025Image2 from '../images/HI2025_2.jpg';
import HI2025Image3 from '../images/HI2025_3.jpg';
import HI2025Image4 from '../images/HI2025_4.jpg';
import JHF2025_1 from '../images/JHF2025_1.jpg';
import JHF2025_2 from '../images/JHF2025_2.jpg';
import JHF2025_3 from '../images/JHF2025_3.jpg';


// --- タイムライン用のアイコン定義 ---
const SchoolIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-school-icon lucide-school"><path d="M14 21v-3a2 2 0 0 0-4 0v3"/><path d="M18 5v16"/><path d="m4 6 7.106-3.79a2 2 0 0 1 1.788 0L20 6"/><path d="m6 11-3.52 2.147a1 1 0 0 0-.48.854V19a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a1 1 0 0 0-.48-.853L18 11"/><path d="M6 5v16"/><circle cx="12" cy="9" r="2"/></svg>);
const CodeIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"> <path d="m18 16 4-4-4-4" /><path d="m6 8-4 4 4 4" /><path d="m14.5 4-5 16" /> </svg> );
const TrophyIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"> <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" /><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" /><path d="M4 22h16" /><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" /><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" /><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" /> </svg> );
const PlaneIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"> <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1.5-1.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" /> </svg> );
const FlaskIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"> <path d="M9 2v10.3A5.002 5.002 0 0 0 12 22a5 5 0 0 0 3-1.7V2" /><path d="M6 2h12" /> </svg> );
const HandIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"> <path d="M18 18h-2.4c-1 0-1.9-.6-2.3-1.4l-2.6-5.2c-.3-.8-.9-1.4-1.7-1.4H4V6.5c0-1.4 1.1-2.5 2.5-2.5S9 5.1 9 6.5V10" /><path d="M18 22a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-4.4" /> </svg> );
const BriefcaseIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="14" x="2" y="7" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg> );

// --- タイムラインの画像・アイコンマッピング（翻訳不要のデータ） ---
const timelineMedia = [
    { icon: <SchoolIcon /> },
    { icon: <CodeIcon /> },
    { icon: <TrophyIcon /> },
    { images: [DrowsinessGlassesImage], icon: <CodeIcon /> },
    { images: [TaiwanPBLImage, TaiwanPBLImage2, TaiwanPBLImage3], icon: <PlaneIcon /> },
    { images: [SitToStandImage], icon: <FlaskIcon /> },
    { images: [AssistGloveImage], icon: <HandIcon /> },
    { images: [ExpoImage1, ExpoImage2, ExpoImage3, ExpoImage4], icon: <SchoolIcon /> },
    { images: [HI2025Image1, HI2025Image2, HI2025Image3, HI2025Image4], icon: <SchoolIcon /> },
    { icon: <BriefcaseIcon /> },
    { images: [JHF2025_1, JHF2025_3, JHF2025_2], icon: <SchoolIcon /> },
    { icon: <SchoolIcon /> },
];

// スキルプレビュー用の画像マッピング
const skillImages = [pythonImage, javascriptImage, CImage, RaspiImage];

const Homepage = () => {
    const { t } = useTranslation();
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    // --- タイムラインイベントを翻訳データから構築 ---
    const translatedEvents = t('home.timelineEvents', { returnObjects: true });
    const timelineEvents = Array.isArray(translatedEvents)
      ? translatedEvents.map((evt, i) => ({
          ...evt,
          images: timelineMedia[i]?.images || null,
          icon: timelineMedia[i]?.icon || <SchoolIcon />,
        }))
      : [];

    // --- スキルプレビューを翻訳データから構築 ---
    const skillKeys = ['python', 'javascript', 'c', 'raspi'];
    const skillsPreview = skillKeys.map((key, i) => ({
      image: skillImages[i],
      alt: t(`home.skillItems.${key}.title`) + ' logo',
      title: t(`home.skillItems.${key}.title`),
      desc: t(`home.skillItems.${key}.desc`),
    }));

    // --- ここからスワイプ検出ロジック ---
    const touchStartXRef = useRef(null);
    const touchStartYRef = useRef(null);
    const touchMovedRef = useRef(false);
    const SWIPE_THRESHOLD = 40;

    const nextImage = (len) => {
        setCurrentImageIndex((idx) => (idx + 1) % len);
    };
    const prevImage = (len) => {
        setCurrentImageIndex((idx) => (idx - 1 + len) % len);
    };

    const handleTouchStart = (e) => {
        const touch = e.touches[0];
        touchStartXRef.current = touch.clientX;
        touchStartYRef.current = touch.clientY;
        touchMovedRef.current = false;
    };

    const handleTouchMove = (e) => {
        const touch = e.touches[0];
        const dx = touch.clientX - touchStartXRef.current;
        const dy = touch.clientY - touchStartYRef.current;
        if (Math.abs(dx) > Math.abs(dy)) {
            e.preventDefault();
            touchMovedRef.current = true;
        }
    };

    const handleTouchEnd = (e) => {
        if (!selectedEvent?.images || selectedEvent.images.length <= 1) return;
        if (touchStartXRef.current == null) return;

        const len = selectedEvent.images.length;
        const endX = e.changedTouches?.[0]?.clientX ?? touchStartXRef.current;
        const deltaX = endX - touchStartXRef.current;

        if (deltaX < -SWIPE_THRESHOLD) {
            nextImage(len);
        } else if (deltaX > SWIPE_THRESHOLD) {
            prevImage(len);
        }

        touchStartXRef.current = null;
        touchStartYRef.current = null;
        touchMovedRef.current = false;
    };

    const handleIconClick = (event) => {
        setSelectedEvent(event);
        setCurrentImageIndex(0);
    };

    const closeDetailsBox = () => {
        setSelectedEvent(null);
    };

    return (
        <PageLayout>
            <main>
                {/* 詳細表示ボックス */}
                {selectedEvent && (
                    <>
                        <div className="details-backdrop" onClick={closeDetailsBox}></div>
                        <div className="details-box-from-top">
                            <div className="details-box-content">
                                {/* 画像スライダー */}
                                {selectedEvent.images && selectedEvent.images.length > 0 && (
                                    <div
                                        className="image-slider-container"
                                        onTouchStart={handleTouchStart}
                                        onTouchMove={handleTouchMove}
                                        onTouchEnd={handleTouchEnd}
                                    >
                                        <img 
                                            src={selectedEvent.images[currentImageIndex]} 
                                            alt={selectedEvent.title} 
                                            className="details-image" 
                                        />
                                        {selectedEvent.images.length > 1 && (
                                            <div className="image-indicators">
                                                {selectedEvent.images.map((_, index) => (
                                                    <span
                                                        key={index}
                                                        className={`indicator-dot ${index === currentImageIndex ? 'active' : ''}`}
                                                        onClick={() => setCurrentImageIndex(index)}
                                                    ></span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                                
                                {/* テキストコンテンツ */}
                                <div className="text-content">
                                    <time>{selectedEvent.date}</time>
                                    <h3>{selectedEvent.title}</h3>
                                    <p>{selectedEvent.description}</p>
                                    {selectedEvent.details && (
                                      <div className="more-details">
                                        {selectedEvent.details.split('\n').map((line, i) => (
                                          <React.Fragment key={i}>
                                            {i > 0 && <br />}
                                            {line}
                                          </React.Fragment>
                                        ))}
                                      </div>
                                    )}
                                </div>
                            </div>
                            <button onClick={closeDetailsBox} className="close-button">×</button>
                        </div>
                    </>
                )}

                {/* --- メインページコンテンツ --- */}
                <div className='portfolio'>
                    <h2>{t('home.portfolio')}</h2>
                </div>
                <div className='name'>
                    <img src={ProfileImage} alt={t('home.profileAlt')} />
                </div>

                {/* 自己紹介ボックス */}
                <div className="container">
                    <div className='myslef-textbox'>
                        <h5>{t('home.selfIntro')}</h5>
                        <p><strong>{t('home.motto')}</strong></p>
                        <p>{t('home.greeting')}</p>
                        <p>{t('home.research_desc')}</p>
                        <p>{t('home.activity_desc')}</p>
                    </div>
                </div>

                {/* 経歴 */}
                <div className="container">
                    <div className='my-timeline-wrapper'>
                        <h2 className="title">{t('home.timeline')}</h2>
                        <div className="timeline-container">
                            {timelineEvents.map((event, index) => (
                                <div key={index} className="timeline-item">
                                    <div className="timeline-item-content">
                                        <div className="timeline-icon" onClick={() => handleIconClick(event)}>
                                            {event.icon}
                                        </div>
                                        <time className="timeline-date">{event.date}</time>
                                        <h3 className="timeline-title">{event.title}</h3>
                                        <p className="timeline-description">{event.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* スキル */}
                <section id="skill" className='container text-center'>
                    <div className="skills-container">
                        <h2 className="title">{t('home.skills')}</h2>
                        <div className="skills-grid">
                            {skillsPreview.map((skill) => (
                                <div className="skill-card" key={skill.title}>
                                    <img src={skill.image} alt={skill.alt} />
                                    <h4>{skill.title}</h4>
                                    <p>{skill.desc}</p>
                                </div>
                            ))}
                        </div>
                        <Link to="/skills" className="btn btn-primary">{t('home.viewAllSkills')}</Link>
                    </div>
                </section>
            </main>
        </PageLayout>
    );
};

export default Homepage;
